import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useParams } from "react-router-dom";
import { getJournalByID } from "./services/journal.services";
import { clearJournalDetails } from "./journalSlice";
import {
  checkAcessRights,
  formatIndianNumber,
  getAccountingYear,
} from "../../_helper/helper";
import moment from "moment";
import { PRINT_ACCESS } from "../../_contstants/common";
import { Button } from "@progress/kendo-react-buttons";

const JournalVoucherPrint: React.FC = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const journal_voucher_guid = params?.journal_voucher_guid;
  const JournalDetail = useAppSelector((state) => state.journal.JournalDetail);
  const isPrintAccess = checkAcessRights("/journal", PRINT_ACCESS);

  useEffect(() => {
    if (journal_voucher_guid) {
      const handleDriverVisitPrint = async () => {
        const res = await dispatch(getJournalByID(journal_voucher_guid));
        if (res.meta.requestStatus === "fulfilled") {
          window.print();
        }
      };
      handleDriverVisitPrint();
    }
  }, [journal_voucher_guid]);

  useEffect(() => {
    return () => {
      dispatch(clearJournalDetails());
    };
  }, []);

  let totalDebitAmount = 0;
  let totalCreditAmount = 0;

  JournalDetail?.journal_voucher_entry &&
    JournalDetail?.journal_voucher_entry?.length > 0 &&
    JournalDetail?.journal_voucher_entry?.map((payment: any) => {
      if (payment?.debit_credit === "Debit") {
        totalDebitAmount += +payment?.amount;
      } else if (payment?.debit_credit === "Credit") {
        totalCreditAmount += +payment?.amount;
      }
    });

  return (
    <>
      <div className="container p-4 drivervisit-print-page">
        <div className="position-relative no-visible-print-btn text-end p-2">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => window.print()}
            >
              Print
            </Button>
          )}
        </div>
        <p className="text-center">
          <b>Harihar Foods Pvt. Ltd. {getAccountingYear()}</b>
          <br />
          519/1, Nr Ramol Police Chowky
          <br />
          Phase IV, G.I.D.C. Vatva, Ahmedabad 382445
          <br />
          Tel (Off) 079-25841773/25840855 <br />
          FSSAI No: 10012021000359 <br />
          State Name: Gujarat, Code: 24 <br />
          CIN: U15499GJ1994PTC021520 <br />
          E-Mail: marketing@shreeganeshmasala.com
        </p>
        <br />
        <p className="text-center">
          <b>
            {/* {JournalDetail?.voucher_type} */}
            Journal Voucher
          </b>
        </p>
        <div className="d-flex justify-content-between">
          <p>
            No.:{" "}
            <span className="fw-bold">
              {JournalDetail?.journal_voucher_no_string}
            </span>
          </p>
          <p>
            Dated :{" "}
            <span className="fw-bold">
              {JournalDetail?.journal_voucher_date
                ? moment(
                    JournalDetail?.journal_voucher_date,
                    "DD MMM YYYY HH:mm"
                  ).format("DD-MMM-YYYY")
                : ""}
            </span>
          </p>
        </div>
        <table className="drivervisit-print-table">
          <tr
            style={{
              borderTop: "1px solid black",
              borderBottom: "1px solid black",
            }}
          >
            <th style={{ width: "60%" }}>Particulars</th>
            <th
              style={{
                textAlign: "end",
                width: "20%",
                borderLeft: "1px solid black",
              }}
            >
              Debit
            </th>
            <th
              style={{
                textAlign: "end",
                width: "20%",
                borderLeft: "1px solid black",
              }}
            >
              Credit
            </th>
          </tr>
          <tr>
            <td className="fw-bold">Account :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          {JournalDetail?.journal_voucher_entry &&
            JournalDetail?.journal_voucher_entry?.length > 0 &&
            JournalDetail?.journal_voucher_entry?.map((journal: any) => {
              return (
                <tr>
                  <td className="ps-3">
                    {journal.account_name}
                    <table style={{ width: "95%", marginLeft: "5%" }}>
                      {journal.journal_voucher_entry_referance &&
                        journal.journal_voucher_entry_referance.length > 0 &&
                        journal.journal_voucher_entry_referance?.map(
                          (ref: any) => {
                            return (
                              <tr>
                                <td>{ref?.refernace_name}</td>
                                <td>
                                  <p className="m-0 text-end">
                                    {formatIndianNumber(ref?.referance_amount)}
                                    {ref?.referance_type === "Debit"
                                      ? " Dr"
                                      : ref?.referance_type === "Credit"
                                      ? " Cr"
                                      : ""}
                                  </p>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </table>
                  </td>
                  <td
                    className="fw-bold text-end"
                    style={{ borderLeft: "1px solid black" }}
                  >
                    {journal.debit_credit === "Debit"
                      ? formatIndianNumber(journal.amount)
                      : ""}
                  </td>
                  <td
                    className="fw-bold text-end"
                    style={{ borderLeft: "1px solid black" }}
                  >
                    {journal.debit_credit === "Credit"
                      ? formatIndianNumber(journal.amount)
                      : ""}
                  </td>
                </tr>
              );
            })}
          <tr>
            <td className="fw-bold pt-3">On Account of :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          {JournalDetail?.remarks ? (
            <tr>
              <td className="ps-3">{JournalDetail?.remarks}</td>
              <td style={{ borderLeft: "1px solid black" }}></td>
              <td style={{ borderLeft: "1px solid black" }}></td>
            </tr>
          ) : null}
          {/* <tr>
            <td className="fw-bold pt-3">Amount (in words) :</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr>
          <tr>
            <td className="ps-3">{convertToWords(totalAmount || 0)}</td>
            <td style={{ borderLeft: "1px solid black" }}></td>
          </tr> */}
          <tr>
            <td style={{ borderBottom: "1px solid black" }}></td>
            <td
              className="fw-bold text-end"
              style={{ border: "1px solid black", borderRight: "none" }}
            >
              Rs. {formatIndianNumber(totalDebitAmount || 0)}
            </td>
            <td
              className="fw-bold text-end"
              style={{ border: "1px solid black", borderRight: "none" }}
            >
              Rs. {formatIndianNumber(totalCreditAmount || 0)}
            </td>
          </tr>
        </table>
        <div className="row mt-2">
          <div className="col-12">
            <p className="text-end">Authorised Signatory</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default JournalVoucherPrint;
